module.exports = __webpack_public_path__ + "static/media/miehuoqi.d08af078.png";